export default {
  // components
  Email: 'البريد الإلكتروني',
  'For example abc@example.com': 'على سبيل المثال abc@example.com',
  'Phone number': 'رقم الهاتف',
  'For example <bdo>+966551234567</bdo>': 'علي سبيل المثال <bdo>+966551234567</bdo>',
  '{{label}} (optional)': '{{label}} (اختياري)',
  'Contact us': 'اتصل بنا',
  Dashboard: 'لوحة التحكم',
  'Please, fix application data': 'من فضلك، أصلح بيانات الطلب',
  Continue: 'متابعة',
  'Try again': 'حاول ثانية',
  Total: 'المجموع',
  'Please Enter a Valid Personal Phone Number': 'يرجى إدخال رقم هاتف شخصي صالح',
  'Please Enter a Valid Personal Identification Number': 'يرجى إدخال رقم هوية شخصي صالح',
  'Please Enter a Valid Company CR Number or Unified Number':
    'يرجى إدخال رقم شركة صالح أو رقم موحد تجاري',
  Proceed: 'يتابع',
  'VAT 15%': 'ضريبة القيمة المضافة 15٪',
  'Pricing has changed': 'تغيرت الأسعار',
  'Save changes to see total price': 'حفظ التغييرات لرؤية السعر الإجمالي',
  Logout: 'تسجيل خروج',
  Services: 'الخدمات',
  Application: 'طلب',
  Review: 'مراجعة',
  Contract: 'العقد',
  Payment: 'دفع',
  Completion: 'الاكتمال',
  'Drag & Drop your files here or <strong>Browse</strong>':
    'اسحب وأرفق ملفاتك هنا أو <strong>استعرض</strong>',
  'Files supported: JPG, JPEG, DOC, DOCX, PNG, PDF, RTF, GIF. Max size {{size}}':
    'الامتدادات المدعومة: JPG, JPEG, DOC, DOCX, PNG, PDF, RTF, GIF. الحجم الأقصى {{size}}',
  'I agree to the above Fees and Charges mentioned in this page':
    'أوافق على الرسوم والأسعار المذكورة في هذه الصفحة',
  Optional: 'اختياري',
  Yes: 'نعم',
  No: 'لا',
  'Discard changes?': 'هل تريد رفض التغييرات؟',
  Close: 'إغلاق',
  Save: 'حفظ',
  Upload: 'رفع',
  Language: 'اللغة',
  Cancel: 'إلغاء',
  Submit: 'إرسال',
  Back: 'رجوع',
  Copied: 'تم النسخ',
  // Days of week
  MO: 'الاثنين',
  TU: 'الثلاثاء',
  WE: 'الأربعاء',
  TH: 'الخميس',
  FR: 'الجمعة',
  SA: 'السبت',
  SU: 'الأحد',
  // Company type page
  'Get started': 'ابدأ',
  'with Network International': 'مع شركة نتورك إنترناشيونال',
  'Now we know about you, please tell us a little about your business.':
    'الآن بعد أن عرفنا عنك، يرجى إخبارنا قليلاً عن عملك.',
  'I agree to the <1>Terms and Conditions</1> and <3>Privacy Policy</3>':
    'أوافق على <1>الشروط والأحكام</1> و <3>سياسة الخصوصية</3>',
  'Company type': 'نوع الشركة',
  'Business nature': 'طبيعة العمل',
  'Business line': 'خط العمل',
  Confirm: 'تأكيد',
  'Please confirm that your company is not an Aggregator or Marketplace':
    'الرجاء تأكيد أن شركتك ليست مجمعًا لمدفوعات متاجر متعددة',
  'Agree and Continue': 'وافق ومتابعة',
  'Reselect Company Type': 'إعادة اختيار نوع الشركة',
  '<strong>Marketplace</strong> – you operate a platform where multiple merchants come together to sell their own goods or services through one location.':
    '<strong>السوق</strong> - تدير منصة يتجمع فيها العديد من التجار لبيع بضائعهم أو خدماتهم الخاصة من خلال موقع واحد.',
  '<strong>Aggregator</strong> – your business allows 3rd party merchants to use the payment services which you have signed up for.':
    '<strong>مجمع المدفوعات</strong> - يسمح لعملك لتجار جهات خارجية باستخدام خدمات الدفع التي قمت بالتسجيل فيها.',
  '<strong>Small and Medium Enterprise</strong> – you operate your own business selling your own goods or services.':
    '<strong>الشركات الصغيرة والمتوسطة</strong> - تدير عملك الخاص وتبيع بضائعك أو خدماتك الخاصة.',
  'Please select the nature of your business from the list which most closely defines your primary trading purpose.':
    'يرجى اختيار طبيعة عملك الأساسية من القائمة.',
  'Please select the business line which most closely fits your primary trading purpose.':
    'يرجى اختيار خط العمل الذي يلائمك بشكل أساسي.',
  // Get in touch page
  'Get in touch': 'اتصل بنا',
  'Thank you for the information provided so far.': 'نشكرك على المعلومات المقدمة',
  'Due to your business type, we will need one of our dedicated team to take you through the application process to ensure the right services for you.':
    'بسبب نوع عملك، سنحتاج إلى أحد من فريقنا المتخصص لإرشادك خلال عملية التقديم لضمان الخدمات المناسبة لك.',
  'Please contact us via our <1>Contact us page</1> to arrange a call back.':
    'الرجاء الاتصال بنا عبر <1>صفحة "اتصل بنا"</1> لترتيب موعد لإعادة الاتصال.',
  // Lets start
  'Excellent!': 'ممتاز!',
  'Now we know a little bit more about you and your business, we can now move onto the full application process.':
    'الآن بعد أن علمنا المزيد عنك وعملك، يمكننا الآن الانتقال إلى عملية التقديم الكاملة.',
  'This process should take no more than 30 minutes.':
    'يجب ألا تستغرق هذه العملية أكثر من 30 دقيقة.',
  'You can also leave at any point and return by using the same email address you provided to us at the start.':
    'يمكنك أيضًا المغادرة في أي وقت والعودة باستخدام نفس عنوان البريد الإلكتروني الذي زودتنا به في البداية.',
  'Let’s start!': 'لنبدأ!',
  'For successful completion you will need the following documents:':
    'لتسجيل ناجح، ستحتاج إلى المستندات التالية:',
  'Copy of Company or Trade License': 'نسخة من ترخيص الشركة أو التجارة',
  'Passport copy of authorised signatory with Visa':
    'نسخة جواز سفر للموقع المخول بالتوقيع مع التأشيرة',
  'Emirates ID and documents of all partners in business':
    'بطاقة الهوية الوطنية أو الإقامة ومستندات لجميع الشركاء في العمل',
  'Copy of Memorandum/POA for authorised signatory':
    'نسخة من مذكرة التفاهم/وكالة توكيل للموقع المخول بالتوقيع',
  'Copy of Bank Statement with IBAN number': 'نسخة من كشف حساب مصرفي برقم IBAN',
  'Tax registration certificate': 'شهادة تسجيل ضريبة القيمة المضافة',
  'Download File': 'تحميل الملف',
  NORMAL: 'عادي',
  HIGH_RISK: 'عالي المخاطر',
  'CURRENT USER': 'المستخدم الحالي',
  'Current user': 'المستخدم الحالي',

  // Footer
  'Privacy Policy': 'سياسة الخصوصية',
  'Terms and Conditions ': 'الشروط والأحكام',
  'Developers Guide': 'دليل المطورين',
  'Copyright 2025 Network International. All Rights Reserved.':
    'حقوق الطبع والنشر © 2025 نتورك إنترناشيونال. جميع الحقوق محفوظة.',
  'Copyright {{year}} Network International. All Rights Reserved.':
    '© {{year}} نتورك إنترناشونال. جميع الحقوق محفوظة.',
  'All prices are VAT excluded': 'جميع الأسعار لا تشمل ضريبة القيمة المضافة',
  'Change Language': 'تغيير اللغة',
  'SPL Missing': 'العنوان الوطني مفقود',
  'National Address information is missing': 'معلومات العنوان الوطني غير متوفرة',
};
